module.exports = __webpack_public_path__ + "assets/img/teacher (42).1e55b9ea.png";